import type { FocusEvent } from "react";

/**
 * Props para que un input numérico quede con TODO el valor seleccionado al
 * recibir el foco (click o tab), así se tipea encima sin borrar a mano.
 *
 * Se spreadea en el componente: `<InputNumber {...selectAllOnFocus} />`.
 *
 * Va en `onFocus` y no en `onClick` a propósito: `onFocus` dispara una sola vez
 * al entrar, así que un segundo click adentro del input sigue posicionando el
 * cursor donde el usuario lo puso.
 */
export const selectAllOnFocus = {
  onFocus: (e: FocusEvent<HTMLInputElement>) => e.currentTarget.select(),
};
